module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.showAvatar) ? _c('team-member-avatar', {
    attrs: {
      "subject": _vm.comment.commenter,
      "height": "45px",
      "width": "45px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "commenter-comment"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("\n      " + _vm._s(_vm.comment.commenter.name) + "\n      "), _c('span', {
    staticClass: "time pull-right"
  }, [_vm._v(_vm._s(_vm._f("utcFromNow")(_vm.comment.created_at)))])]), _vm._v(" "), (_vm.showHeader) ? _c('p', {
    staticClass: "comment-header"
  }, [_c('router-link', {
    attrs: {
      "to": '/a/document/' + _vm.comment.document.id
    }
  }, [_vm._v(_vm._s(_vm.comment.document.title))])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "comment",
    domProps: {
      "innerHTML": _vm._s(_vm.commentType === 'full' ? _vm.commentBodyFormatted : _vm.comment.excerpt)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27a303f9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/comment.vue
// module id = 515
// module chunks = 0